export class InfectedDataClassificationSize {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "classification",
            "baseName": "classification",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return InfectedDataClassificationSize.attributeTypeMap;
    }
    constructor() {
    }
}
